<div class="row">
  <div class="col">
    <h1 style="text-align: center">{{ "history" | i18n }}</h1>
  </div>
</div>
<ng-container *ngFor="let logEntry of userLogs | async">
  <div class="row">
    <div
      class="col"
      class="log-entry-date">
      {{ logEntry.timestamp * 1000 | date: "dd.MM.yy / HH:mm" }}
      {{ "oClock" | i18n }}
      <span *ngIf="logEntry.editorName">
        - {{ "by" | i18n }} {{ logEntry.editorName }}</span
      >
      <span *ngIf="logEntry.viaCustomer?.displayName">
        | {{ logEntry.viaCustomer?.displayName }}</span
      >
    </div>
  </div>
  <div class="row">
    <div
      class="col"
      class="log-entry-text">
      <ng-container *ngIf="logEntry.category == 'INVITEE'">
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.JOB_REMINDER]">
          {{
            ("jobReminderSent" | i18n) ||
              "Es wurde eine Dienst-Erinnerung an den Benutzer versendet."
          }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="
            logEntry.message == userLogEnum[userLogEnum.JOB_REOPENED_INVITE]
          ">
          <span data-cy="job-reopened-invite-log">
            {{
              ("jobReopenedInviteNotificationSent" | i18n) ||
                "Es wurde eine erneute Anfrage nach Dienst-Wiedereröffnung an den Benutzer versendet."
            }}
          </span>
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.INVITE_REMINDER]">
          {{
            ("reminderSent" | i18n) ||
              "Es wurde eine Anfragen-Erinnerung an den Benutzer versendet."
          }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.INVITE]">
          {{ ("userWasInvited" | i18n) || "Benutzer wurde eingeladen." }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.RE_ASK]">
          {{ ("userWasReasked" | i18n) || "Benutzer wurde erneut eingeladen." }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.BOOKED]">
          {{ ("userWasAccepted" | i18n) || "Benutzer wurde akzeptiert." }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.TRANSFERRED]">
          <div
            *ngIf="logEntry.transferredFrom"
            data-cy="transferredFrom">
            {{ ("userWasTransferredFrom" | i18n) || "Benutzer wurde von " }}
            <b>{{ logEntry.transferredFrom.departmentName }}</b>
            {{ ("transferred" | i18n) || "umgebucht" }}.
            <a
              class="log-entry-link"
              [routerLink]="['/', 'jobs', logEntry.transferredFrom.jobId]">
              {{ ("toOldJob" | i18n) || "Zum alten Dienst" | uppercase }}
            </a>
          </div>
          <div
            *ngIf="logEntry.transferredTo"
            data-cy="transferredTo">
            {{ ("userWasTransferredTo" | i18n) || "Benutzer wurde zu" }}
            <b> {{ logEntry.transferredTo.departmentName }}</b>
            {{ ("transferred" | i18n) || "umgebucht" }}.
            <a
              class="log-entry-link"
              [routerLink]="['/', 'jobs', logEntry.transferredTo.jobId]">
              {{ ("toNewJob" | i18n) || "Zum neuen Dienst" | uppercase }}
            </a>
          </div>
          <span *ngIf="logEntry.transferredTo?.transferReason">
            <b> {{ ("inviteeTransferReason" | i18n) || "Umbuchungsgrund" }}: </b
            >{{ logEntry.transferredTo?.transferReason }}
          </span>
          <span *ngIf="logEntry.transferredFrom?.transferReason">
            <b> {{ ("inviteeTransferReason" | i18n) || "Umbuchungsgrund" }}: </b
            >{{ logEntry.transferredFrom?.transferReason }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.DECLINED]">
          {{ ("userWasDeclined" | i18n) || "Benutzer wurde abgelehnt." }}
          <div
            *ngIf="data.invitee.declineReason && declineReasonEnum?.[data.invitee.declineReason]"
            data-cy="invitee-decline-reason">
            <span>{{ ("reason" | i18n) || "Grund" }}:</span>
            <span
              *ngIf="data.invitee.declineReason === declineReasonEnum.OTHER">
              {{ data.invitee.declineReasonDescription }}
            </span>
            <span
              *ngIf="data.invitee.declineReason !== declineReasonEnum.OTHER">
              {{ "declineReasonEnum." + data.invitee.declineReason! | i18n }}
            </span>
          </div>
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.WORKING]">
          {{
            ("userBookedOnAnotherJob" | i18n) ||
              "Benutzer wurde bei einem anderen Dienst gebucht."
          }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.JOB_CANCELED]">
          {{
            ("userAvailableBecauseJobCancelled" | i18n) ||
              "Benutzer ist wieder verfügbar, da anderer Dienst storniert wurde."
          }}
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.INVITEE_CANCELED]">
          {{ ("userWasCancelled" | i18n) || "Benutzer wurde storniert." }}
          <div
            *ngIf="data.invitee.cancelReason"
            data-cy="invitee-cancel-reason">
            <span>{{ ("reason" | i18n) || "Grund" }}:</span>
            <span *ngIf="data.invitee.cancelReason?.enableDescription">
              {{ data.invitee.cancelReasonDescription }}
            </span>
            <span
              *ngIf="
                data.invitee.cancelReason.id === jobCanceledCancelReasonId &&
                data.cancelReasonDescription
              ">
              {{
                data.invitee.cancelReason.displayName[lang] +
                  ": " +
                  data.cancelReasonDescription
              }}
            </span>
            <span
              *ngIf="
                !data.invitee.cancelReason.enableDescription &&
                (data.invitee.cancelReason.id !== jobCanceledCancelReasonId ||
                  !data.cancelReasonDescription)
              ">
              {{ data.invitee.cancelReason.displayName[lang] }}
            </span>
          </div>
          <span
            class="log-entry-notifiedVia"
            *ngIf="logEntry.notifiedVia?.email || logEntry.notifiedVia?.sms">
            Via. {{ logEntry.notifiedVia?.email === true ? "E-MAIL," : "" }}
            {{ logEntry.notifiedVia?.sms === true ? "SMS" : "" }}
          </span>
        </ng-container>
        <ng-container
          *ngIf="
            logEntry.message == userLogEnum[userLogEnum.POSSIBLE_CANDIDATE]
          ">
          {{
            ("userSubmittedAsPossibleCandidate" | i18n) ||
              "Benutzer wurde als möglicher Kandidat eingereicht"
          }}
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.SELF_SIGN_IN]">
          <ng-container
            *ngIf="logEntry.selfSignInWithAvailability === undefined">
            {{
              ("userSelfSignIn" | i18n) ||
                "Benutzer ohne Einladung stellt sich selbst zur Verfügung"
            }}
          </ng-container>
          <ng-container *ngIf="logEntry.selfSignInWithAvailability === true">
            {{
              ("userSelfSignInWithAvailability" | i18n) ||
                "Benutzer mit Verfügbarkeit stellt sich selbst zur Verfügung"
            }}
          </ng-container>
          <ng-container *ngIf="logEntry.selfSignInWithAvailability === false">
            {{
              ("userSelfSignInWithoutAvailability" | i18n) ||
                "Benutzer ohne Verfügbarkeit stellt sich selbst zur Verfügung"
            }}
          </ng-container>
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.INVITEE_REPLACED]">
          {{
            ("userWasReplaced" | i18n) ||
              "Benutzer wurde durch einen anderen Pooler ersetzt."
          }}
        </ng-container>
        <ng-container
          *ngIf="
            !logEntry.editorId || logEntry.editorId === logEntry.userId;
            else dispEditLogEntry
          ">
          <ng-container
            *ngIf="logEntry.message == userLogEnum[userLogEnum.AVAILABLE]">
            {{ ("userHasAccepted" | i18n) || "Benutzer hat angenommen." }}
          </ng-container>
          <ng-container
            *ngIf="
              logEntry.message == userLogEnum[userLogEnum.UNAVAILABLE] &&
              !data.invitee.selfSignIn
            ">
            {{ ("userHasDeclined" | i18n) || "Benutzer hat abgelehnt." }}
          </ng-container>
          <ng-container
            *ngIf="
              logEntry.message == userLogEnum[userLogEnum.PARTIAL_AVAILABLE] &&
              !data.invitee.selfSignIn
            ">
            {{
              ("userHasPartiallyAccepted" | i18n) ||
                "Benutzer hat teilweise zugesagt."
            }}
          </ng-container>
          <ng-container
            *ngIf="
              logEntry.message == userLogEnum[userLogEnum.PARTIAL_TIMES_EDIT] &&
              !data.invitee.selfSignIn
            ">
            {{
              ("userHasEditedPartialTimes" | i18n) ||
                "Benutzer hat Zeiten bearbeitet."
            }}
          </ng-container>
          <ng-container
            *ngIf="
              logEntry.message == userLogEnum[userLogEnum.UNAVAILABLE] &&
              data.invitee.selfSignIn
            ">
            {{
              ("userSelfSignInHasDeclined" | i18n) ||
                "Benutzer ohne Einladung hat abgelehnt."
            }}
          </ng-container>
        </ng-container>
        <ng-template #dispEditLogEntry>
          <ng-container
            *ngIf="logEntry.message == userLogEnum[userLogEnum.AVAILABLE]">
            {{
              ("userSetToAvailable" | i18n) ||
                'Benutzer wurde von einem Disponenten auf "Verfügbar" gesetzt.'
            }}
          </ng-container>
          <ng-container
            *ngIf="logEntry.message == userLogEnum[userLogEnum.UNAVAILABLE]">
            {{
              ("userSetToUnavailable" | i18n) ||
                'Benutzer wurde von einem Disponent auf "nicht Verfügbar" gesetzt.'
            }}
          </ng-container>
        </ng-template>
      </ng-container>
      <ng-container
        *ngIf="logEntry.category == 'SMS' || logEntry.category == 'EMAIL'">
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.INVITE]">
          {{
            ("invitedByCategory" | i18n: { category: logEntry.category }) ||
              "Benutzer wurde per " + logEntry.category + " eingeladen."
          }}
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.JOB_CANCELED]">
          {{
            ("cancelledByCategory" | i18n: { category: logEntry.category }) ||
              "Benutzer wurde per " + logEntry.category + " storniert."
          }}
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.BOOKED]">
          {{
            ("acceptedByCategory" | i18n: { category: logEntry.category }) ||
              "Benutzer wurde per " + logEntry.category + " akzeptiert."
          }}
        </ng-container>
        <ng-container
          *ngIf="logEntry.message == userLogEnum[userLogEnum.DECLINED]">
          {{
            ("declinedByCategory" | i18n: { category: logEntry.category }) ||
              "Benutzer wurde per " + logEntry.category + " abgelehnt."
          }}
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>
